import {call, query} from './calls';

export const Credentials = {
    getByAccountId: (accountId) => query(`SELECT * FROM Credentials WHERE accountId=${accountId}`),
    getById: (Id) => query(`SELECT * FROM Credentials WHERE id=${Id}`),
    getActiveByAccountId: (accountId) => query(`SELECT * FROM Credentials WHERE accountId=${accountId} and active = true`),
    delete: (id) => call(`/Credentials/${id}`, "DELETE"),
    create: (credential) => call("/Credentials", "POST", credential),
    update: (id, body) => call(`/Credentials/${id}`, "PUT", body)
};